import React, { useState, useEffect } from 'react';

import { 
    GeneralTable, Dropdown, SearchBox, ConfirmationModal,
    Datepicker, FormCheckbox, SubmenuTooltip, MoreButton
} from "components";
import CompanyOverview from 'modules/distributorPortal/companyOverview/CompanyOverview';

import { convertArrayToDropdownArrayFormat, func_validation, getTotalCountFromHeader, isObjectEmpty, isStringEqual_caseInsensitive } from 'functions';
import { homeColumns } from './homeColumns';

import 'assets/scss/distributorPortal/modules/home.scss';
import { MultiFilters } from 'components/filters/MultiFilters';



export function HomePresentation(props) {
    const { oneClickActionDetails,
            getCompanyDetails_requesting, companyDetails, companyDetailsHeaders 
    } = props;

    // States
    
    const [isCompanyOverviewVisible, setIsCompanyOverviewVisible] = useState(false);
    const [selectedComID, setSelectedComID] = useState("");

    const [tableFilterValue, setTableFilterValue] = useState("comId");
    const [comIDSearchTerm, setComIDSearchTerm] = useState("");
    const [isTrial, setIsTrial] = useState();
    const [isSuspended, setIsSuspended] = useState();
    const [email, setEmail] = useState();

    let totalUnbilledInvoices = func_validation.getObjectPropertyValue(oneClickActionDetails, "Active Accounts");
    totalUnbilledInvoices = (func_validation.isNumberValid(totalUnbilledInvoices))? totalUnbilledInvoices: 0;
    let totalUnpostedInvoice = func_validation.getObjectPropertyValue(oneClickActionDetails, "TotalUnpostInvoice");
    totalUnpostedInvoice = (func_validation.isNumberValid(totalUnpostedInvoice))? totalUnpostedInvoice: 0;
    let totalPendingSendInvoice = func_validation.getObjectPropertyValue(oneClickActionDetails, "Trial Accounts");
    totalPendingSendInvoice = (func_validation.isNumberValid(totalPendingSendInvoice))? totalPendingSendInvoice: 0;
    
    let actionBoardDetail = [
        {
            totalIncompleteProcesses: totalUnbilledInvoices,
            typeOfIncompleteProcess: "Active Accounts",
        },
        // {
        //     totalIncompleteProcesses: totalUnpostedInvoice,
        //     typeOfIncompleteProcess: "Active Licenses",
        // },
        {
            totalIncompleteProcesses: totalPendingSendInvoice,
            typeOfIncompleteProcess: "Account on Trials",
        },
    ];

    // Action Board (Data)
    function getActionBoardData() {
        if (func_validation.isFunction(props.getOneClickActionDetails)) 
            props.getOneClickActionDetails();
    }
    useEffect(() => {
        // Get action board details
        getActionBoardData();
    }, []);

    // Action Board (Display)
    let actionBoards = [];
    if (func_validation.isArrayNotEmpty(actionBoardDetail)) {
        actionBoards = actionBoardDetail.map((detail, idx) => {
            // Data
            let openWarningModal = func_validation.getObjectPropertyValue(detail, "openWarningModal", "");
            let totalIncompleteProcesses = func_validation.getObjectPropertyValue(detail, "totalIncompleteProcesses", "");
            let typeOfIncompleteProcessTxt = func_validation.getObjectPropertyValue(detail, "typeOfIncompleteProcess", "");
            let actionTxt = func_validation.getObjectPropertyValue(detail, "actionTxt", "");

            let isBoardEmpty = ((func_validation.isNumberValid(totalIncompleteProcesses) &&
                                    totalIncompleteProcesses == 0) &&
                                    func_validation.isStringTrimEmpty(typeOfIncompleteProcessTxt));

            return (
                <div key={idx} className={"distributorPortal-home-boards-specificBoardWrapper "}>
                    <div className={"distributorPortal-home-boards-specificBoard " + 
                                                (isBoardEmpty? "":"distributorPortal-home-boards-specificBoard_primaryBackground ")}>
                        {(!isBoardEmpty)?(
                            <React.Fragment>
                                <div className={"distributorPortal-home-specificBoard-action text-right"}
                                    onClick={() => { openWarningModal(true); }}
                                >
                                    {actionTxt}
                                </div>
                                <div className="distributorPortal-home-specificBoard-totalIncomplete">
                                    {totalIncompleteProcesses}
                                </div>
                                <div className="distributorPortal-home-specificBoard-incompleteType">
                                    {typeOfIncompleteProcessTxt}
                                </div>
                            </React.Fragment>
                        ):""}
                    </div>
                </div>
            )
        });
    }

    // Filter
    let tableFilterOptions = [
        {
            label: "Company ID",
            value: "comId"
        },
        {
            label: "Company Name",
            value: "comName"
        },
        {
            label: "Email",
            value: "comEmail"
        },
        {
            label: "Status",
            value: "isTrial"
        },
        {
            label: "Suspended",
            value: "isSuspended"
        }
    ];

    // Table
    function handleRowClick(rowDetails) {
        if (func_validation.isObjectNotEmpty(rowDetails)) {
            let values = rowDetails?.values;

            let companyID = values?.companyID;
            let isTrial = values?.isTrial; 
            let isSuspended = values?.isSuspended; 
            let email = values?.email;

            setSelectedComID(companyID);
            setIsTrial(isTrial);
            setIsSuspended(isStringEqual_caseInsensitive(isSuspended, "yes"));
            setEmail(email);
            setIsCompanyOverviewVisible(true);
        }
    }
    
    return (
        <div className="distributorPortal-home">

            {(isCompanyOverviewVisible)? (
                <CompanyOverview 
                    comID={selectedComID}
                    isTrial={isTrial}
                    isSuspended={isSuspended}
                    email={email} 
                    setIsCompanyOverviewVisible={setIsCompanyOverviewVisible}
                    updateParentState_visiblity={setIsCompanyOverviewVisible}
                />
            ):(
                <React.Fragment>
                    <div className="distributorPortal-home-header">
                        {/* Title */}
                        <div className="distributorPortal-home-headerTitle pageHeaderTitle ">
                            Home
                        </div>

                        {/* Action Boards */}
                        <div className="distributorPortal-home-headerActionBoard">
                            {/* Title */}
                            {/* <div className={"distributorPortal-home-actionBoardTitle"}>
                                One-Click Action Boards
                            </div> */}

                            {/* List of Boards */}
                            <div className="distributorPortal-home-actionBoardBoards d-flex">
                                {actionBoards}
                            </div>
                        </div>

                    </div>

                    <div className="distributorPortal-home-body">
                        <GeneralTable
                            columns={homeColumns.getColumns()}
                            data={companyDetails}
                            getTableData={props.getTableDetails}

                            outerTableHeader={(props) => {
                                const { filterOptions, setFilterOptions } = props;

                                return (
                                    <div className={"distributorPortal-home-outerTableHeader d-flex justify-content-between align-items-center"}>
                                        <MultiFilters
                                            defaultFilterOption={{
                                                label: "COM ID", 
                                                propertyName: "comId",
                                                placeholder: "COM ID",
                                                inputType: "search",
                                                isInputDigitOnly: true
                                            }}
                                            filterOptions={[
                                                {
                                                    label: "COM ID", 
                                                    propertyName: "comId",
                                                    placeholder: "COM ID",
                                                    inputType: "search",
                                                    isInputDigitOnly: true
                                                },
                                                {
                                                    label: "Company Name", 
                                                    propertyName: "comName",
                                                    placeholder: "Company Name",
                                                    inputType: "search"
                                                },
                                                {
                                                    label: "Email", 
                                                    propertyName: "comEmail",
                                                    placeholder: "Email",
                                                    inputType: "search"
                                                },
                                                {
                                                    label: "Status", 
                                                    propertyName: "isTrial",
                                                    placeholder: "Status",
                                                    options: convertArrayToDropdownArrayFormat(["Trial", "Active"]),
                                                    inputType: "dropdown"
                                                },
                                                {
                                                    label: "Suspended", 
                                                    propertyName: "suspended",
                                                    placeholder: "Suspended",
                                                    options: convertArrayToDropdownArrayFormat(["Yes", "No"]),
                                                    inputType: "dropdown"
                                                },
                                            ]}
                                            dropdownPlaceholder={"Select Filter"}
                                            onApplyFilter={(inputFilters) => {
                                                // find matched tab
                                                setFilterOptions(isObjectEmpty(inputFilters)? {}
                                                    :{ 
                                                        ...filterOptions,
                                                        ...inputFilters,
                                                        isTrial: inputFilters?.isTrial? inputFilters?.isTrial === "Trial":undefined,
                                                        suspended: inputFilters?.suspended? inputFilters?.suspended === "Yes":undefined
                                                    });
                                            }}
                                        />
                                    </div>
                                )
                            }}

                            onRowClick={handleRowClick}

                            isUsingPagination
                            totalRecords={getTotalCountFromHeader(companyDetailsHeaders)}

                            isTableDataLoading={getCompanyDetails_requesting}
                            isAllRowsClickable isColumnResizeable
                            isTableOddRowsDarken isAllColumnWidthEqual
                        />
                    </div>
                </React.Fragment>
            )}
        </div>
    );
}
